export default "__VITE_ASSET__DlXc0slL__"